import { render, staticRenderFns } from "./TargetProfile.vue?vue&type=template&id=8a406be2&scoped=true"
import script from "./TargetProfile.vue?vue&type=script&lang=ts"
export * from "./TargetProfile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a406be2",
  null
  
)

export default component.exports